// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");

function Form__Checkbox$CheckMark(props) {
  var checked = props.checked;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("svg", {
                    children: JsxRuntime.jsx("path", {
                          d: "M27.2 3.2l-16 15.808-6.4-6.016-4.8 4.8 11.2 11.008 20.8-20.8-4.8-4.8z",
                          fill: "currentColor",
                          fillRule: "evenodd"
                        }),
                    "aria-hidden": true,
                    height: "10",
                    width: "10",
                    viewBox: "0 0 32 32"
                  }),
              className: TailwindMerge.twMerge([
                    "mt-0.5 w-3.5 h-3.5 mr-2 flex justify-center items-center border border-solid",
                    "peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-tan-blue-500",
                    checked !== undefined && checked ? "border-tan-blue-500 bg-tan-blue-500 text-white" : "border-gray-300 bg-white text-transparent"
                  ])
            });
}

var CheckMark = {
  make: Form__Checkbox$CheckMark
};

function Form__Checkbox(props) {
  var __mobileStyles = props.mobileStyles;
  var label = props.label;
  var disabled = props.disabled;
  var checked = props.checked;
  var id = props.id;
  var mobileStyles = __mobileStyles !== undefined ? __mobileStyles : true;
  return JsxRuntime.jsxs("label", {
              children: [
                JsxRuntime.jsx("input", {
                      className: "sr-only peer",
                      id: id,
                      checked: checked,
                      disabled: disabled,
                      name: props.name,
                      type: "checkbox",
                      onFocus: props.onFocus,
                      onBlur: props.onBlur,
                      onChange: props.onChange
                    }),
                JsxRuntime.jsx(Form__Checkbox$CheckMark, {
                      checked: checked
                    }),
                label !== undefined ? JsxRuntime.jsx("span", {
                        children: label
                      }) : null
              ],
              className: TailwindMerge.twMerge([
                    "min-h-[18px] text-base leading-tight flex \n      font-normal m-0 relative select-none",
                    Core__Option.getOr(checked, false) ? "text-zinc-700" : "text-zinc-500",
                    Core__Option.getOr(disabled, false) ? "opacity-50 cursor-not-allowed" : "opacity-100 cursor-pointer",
                    mobileStyles ? TailwindMerge.twMerge([
                            "md:p-0 md:rounded-none md:border-none w-full",
                            "p-2.5 rounded-md border border-solid",
                            Core__Option.getOr(checked, false) ? "border-tan-blue-500" : "border-zinc-300"
                          ]) : ""
                  ]),
              disabled: disabled,
              htmlFor: id
            });
}

var make = Form__Checkbox;

exports.CheckMark = CheckMark;
exports.make = make;
/* tailwind-merge Not a pure module */
